/* eslint-disable react/display-name */
import * as React from 'react';

const Marker = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g>
      <path
        d="M12.54,2a6.89,6.89,0,0,1,0,9.42L8,16,3.46,11.4A6.89,6.89,0,0,1,3.46,2l0,0a6.17,6.17,0,0,1,9,0ZM11.41,3.24l0,0a4.61,4.61,0,0,0-6.69,0l0,0a5.1,5.1,0,0,0,0,7L8,13.64l3.37-3.41A5.12,5.12,0,0,0,11.41,3.24ZM8,4.33a2,2,0,0,1,1.92,2A2,2,0,0,1,8,8.33a2,2,0,0,1-1.92-2A2,2,0,0,1,8,4.33Z"
        style={{ fill: 'inherit', fillRule: 'evenodd' }}
      />
    </g>
  </svg>
);

export default Marker;
